import { render, staticRenderFns } from "./ContentLoaderBookingPassenger.vue?vue&type=template&id=7a0babe1&"
import script from "./ContentLoaderBookingPassenger.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderBookingPassenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports